var React = require('react');

function ArrowTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m8.554 2.497-.052-.052-.052.052h.104Zm.805.805V18H7.64V3.306L1.216 9.73-.002 8.513l7.286-7.286-.011-.01L8.487.001l8.526 8.526-1.214 1.214-6.44-6.44Z","fill":"#6C1EFF","fillRule":"evenodd"}));
}

ArrowTop.defaultProps = {"width":"17","height":"18"};

module.exports = ArrowTop;

ArrowTop.default = ArrowTop;
